import { render, staticRenderFns } from "./FreightOptions.vue?vue&type=template&id=5e8f987c&scoped=true"
import script from "./FreightOptions.vue?vue&type=script&lang=ts"
export * from "./FreightOptions.vue?vue&type=script&lang=ts"
import style0 from "./FreightOptions.vue?vue&type=style&index=0&id=5e8f987c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f987c",
  null
  
)

export default component.exports